import React from 'react'
import Image from 'next/image'
import { smilinglady } from '../../../assets'
import styles from './reverseImage.module.css'

const ReverseImage = () => {
  return (
    <div className={styles.imagecontainer}>
      <div className={styles.bigImage}>
        <Image
          src={smilinglady}
          alt='smiling lady'
          width={558.5}
          height={447}
        />
      </div>
    </div>
  )
}

export default ReverseImage
